module.exports = __webpack_public_path__ + "img/DerAufprall6.b935f364.jpg";